
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engineer/skill_check/top",
      function () {
        return require("private-next-pages/engineer/skill_check/top/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engineer/skill_check/top"])
      });
    }
  